/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import 'rxjs/Rx'; 
import { AppModule } from './app/app.module';


// if (environment.production) {
  enableProdMode();
// }
platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
